document.onreadystatechange = function () {
    if (document.readyState === 'complete' && typeof redirect_to_url !== 'undefined') {
        window.location.href = redirect_to_url;
    }
};
